export const applyNoScroll = (): void => {
    document.body.classList.add('no-scroll');
};
